import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/.basehub/react-pump/client-pump-J6HRJBTF.js");
;
import(/* webpackMode: "eager", webpackExports: ["UserRoleStoreProvider"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/role-store.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Bookmarks"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/dashboard-sidebar/bookmarks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentActivity"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/dashboard-sidebar/recent-activity/recent-activity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarLayout"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/dashboard-sidebar/sidebar-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamMembers"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/dashboard-sidebar/team-members/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamStats"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/dashboard-sidebar/team-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardHeader"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RepositoriesList"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/(team)/components/repositories/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamCreateProvider"] */ "/vercel/path0/apps/www/src/app/(dash)/[team-slug]/header/team-dropdown-menu/dialog/context/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicDashHeader"] */ "/vercel/path0/apps/www/src/app/(dash)/public/_components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActivePublicTeamContextProvider"] */ "/vercel/path0/apps/www/src/hooks-data/team/use-active-public-team.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RepoReplicacheProvider"] */ "/vercel/path0/apps/www/src/hooks-data/use-repo-replicache.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamReplicacheProvider"] */ "/vercel/path0/apps/www/src/hooks-data/use-team-replicache.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserPreferencesProvider"] */ "/vercel/path0/apps/www/src/hooks-data/use-user-preferences.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlagsProvider"] */ "/vercel/path0/apps/www/src/lib/flags/provider.tsx");
